import { isSupportedLocale } from '../constants/app.js';
import { deliveryPlanningTranslations } from '../constants/delivery-planning.js';
export function deliveryPlanningLabels(language) {
    const base = language.split('-')[0] ?? language;
    return deliveryPlanningTranslations[isSupportedLocale(base) ? base : 'en'];
}
export function formatDeliveryWeekdays(days, language) {
    const labels = deliveryPlanningLabels(language).days;
    const sorted = [...new Set(days)].sort((a, b) => a - b);
    const parts = [];
    for (let index = 0; index < sorted.length; index += 1) {
        const first = sorted[index];
        if (first === undefined)
            continue;
        let last = first;
        while (sorted[index + 1] === last + 1) {
            index += 1;
            last += 1;
        }
        // Two selected days remain explicit; three or more consecutive days form a range.
        parts.push(last - first >= 2
            ? `${labels[first - 1]}–${labels[last - 1]}`
            : last === first
                ? (labels[first - 1] ?? '')
                : `${labels[first - 1]}/${labels[last - 1]}`);
    }
    return parts.join('/');
}
/** Pure, deterministic formatting shared by editor preview and every PDF path. */
export function formatDeliveryPlanning(plan, language) {
    const labels = deliveryPlanningLabels(language);
    const time = (value) => language.split('-')[0] === 'fr' ? value.replace(':', 'H') : value;
    const groups = new Map();
    if (plan?.enabled)
        for (const window of plan.receivingWindows) {
            const key = `${window.from}-${window.until}`;
            const previous = groups.get(key);
            groups.set(key, { ...window, weekdays: [...(previous?.weekdays ?? []), ...window.weekdays] });
        }
    const receiving = [...groups.values()]
        .sort((a, b) => Math.min(...a.weekdays) - Math.min(...b.weekdays) || a.from.localeCompare(b.from))
        .map((window) => `${formatDeliveryWeekdays(window.weekdays, language)} ${time(window.from)}–${time(window.until)}`)
        .join('; ');
    const transport = plan?.enabled
        ? [...plan.transportRules]
            .sort((a, b) => a.sourceWeekday - b.sourceWeekday)
            .map((rule) => `${labels.days[rule.sourceWeekday - 1]} → ${labels.days[rule.deliveryWeekday - 1]}`)
            .join('; ')
        : '';
    return {
        receiving,
        transport,
        receivingLabel: labels.receiving,
        transportLabel: plan?.transportBasis === 'SHIPMENT' ? labels.transportShipment : labels.transportOrder,
    };
}
//# sourceMappingURL=delivery-planning.js.map